if ( pplang == 'zh-tw') {

    var zh_hk_strings =
    {
        "globals": {
            "_globalnotice": "按此登記",
            "_globalnotice2": regname+"門票現正接受登記！",
            "_globalnoticereg": "立即查看你的電子郵件！我們已經向你發送明天公開售票的指引。",
            "_maintenance": "Ultra Passport目前無法使用，請稍後再試。",
            "_guestnotice": "你必須先登錄才可查看此頁面。"
        },
        "form_labels": {
            "_fullname": "全名",
            "_firstname": "名字",
            "_lastname": "姓氏",
            "_email": "電郵",
            "_emailaddy": "電郵地址",
            "_confirmemailaddy": "確認電郵地址",
            "_birthday": "生日",
            "_location": "地區",
            "_country": "國家",
            "_homeevent": "所在地區活動",
            "_gender": "性別",
            "_password": "密碼",
            "_male": "男性",
            "_female": "女性",
            "_pleaseselect": "請選擇",
            "_signuptitle": "註冊Ultra Passport",
            "_enteryouremail": "請輸入你的電郵地址",
            "_backtologin": "返回登入頁面",
            "_requestnewpass": "要求重新設置密碼",
            "_on": "開啟",
            "_off": "關閉"
        },
        "labels": {
            "_enrollmentavailable": "現正接受註冊",
            "_logintext": "登入",
            "_password": "密碼",
            "_welcome": "歡迎",
            "_account": "帳戶",
            "_myaccount": "我的帳戶",
            "_mypassport": "我的Passport",
            "_events": "活動",
            "_points": "積分",
            "_updates": "最新消息",
            "_signout": "登出",
            "_signin": "登入",
            "_signedin": "已登入",
            "_signuptext": "註冊",
            "_nextlevel": "下一級",
            "_forgot": "忘記密碼？",
            "_subscribed": "訂閱",
            "_helpcenter": "幫助中心",
            "_error": "錯誤",
            "_silver": "白銀",
            "_gold": "黃金",
            "_platinum": "白金"
        },
        "validation_messages": {
            "_gendertext": "你必須選擇性別。",
            "_accepttext": "你必須接受有關條款及細則"
        },
        "_email_verifications": {
            "_resendverify": "重新發送驗證電子郵件",
            "_revalidate": "請檢查你的電子郵箱以驗證你的新電郵地址。",
            "_sendingverification": "正在傳送驗證電郵",
            "_verifysent": "驗證電郵已經傳送",
            "_emailverifydashboard": "請務必認證你的電郵地址以獲取更新和註冊門票。",
            "_emailverifyupdates": "請務必認證你電郵地址作啟用電郵更新"
        },
        "_edit_page": {
            "_editaccount": "編輯帳戶",
            "_nochanges": "未檢測到任何更改",
            "_accountupdated": "帳戶已被更新",
            "_emailupdatedstarted": "新電郵地址必須經過驗證，請檢查您的電子郵箱以確認。",
            "_emailupdatedverified": "新電郵地址己被驗證",
            "_passwordresetsent": "重置密碼郵件已經發送"
        },
        "_footer_signup": {
            "_startinput": "請輸入您的電郵地址以便開始",
            "_starttext": "没有帳戶？登記註冊<br class=\"small-hide\">以參加活動，贏取積分及其他獎賞！",
            "_getstarted": "立即開始"
        },
        "_signup_page": {
            "_createaccount": "建立我的帳戶",
            "_almost": "即將完成",
            "_almost2": "恭喜$user_firstname成功創建您的Ultra Passport<span class=\"tm\"></span>帳戶！",
            "_almost3": "若要激活你的帳戶，<strong><u></u></strong>你必須透過點擊我們剛剛發送給閣下的電郵中的確認鏈接以作驗證你電郵地址之用<strong></strong>",
            "_almost4": "如果你没有收到任何電郵，請檢查垃圾郵件信箱<strong><u><strong><u><strong><u></u></strong></u></strong></u></strong>並把info@e.ultrapassport.com加到您的通信錄中",
            "_almost5": "繼續",
            "_createdsuccess": "帳戶己建立",
            "_createdinfo": "帳戶正在創建中",
            "_accountactivated": "您的帳戶現已激活。",
            "_accountverified": "您的電子郵件地址現在已經通過驗證。",
            "_passwordresetsuccess": "密碼重置成功"
        },
        "_updates": {
            "_updatestext1": "您必須登錄才能登記接收更新。",
            "_updatestextPending": "請驗證您的電郵地址以接收更新",
            "_updatessubsrcibe": "您訂閱了以下的內容更新：",
            "_updatesunsubsrcibe": "您取消訂閱了以下的內容更新："
        },
        "_registration": {
            "_rbtnbuy": "立即購買門票",
            "_regbuy": "購買門票",
            "_rbtnregister": "登記購買門票",
            "_rbtnclosed": "已關閉",
            "_rbtnsoon": "即將推出",
            "_rbtnupdates": "獲取最新通知",
            "_verifyemailregister": "您必須在註冊之前驗證您的電郵地址。",
            "_regbtnhtml": "已註冊",
            "_regerror": "錯誤！",
            "_regerror2": "請再嘗試",
            "_regprocessing": "您的註冊正在進行中...",
            "_registersuccess": "成功註冊",
            "_regaccepted": "您的註冊已被接受",
            "_regaccepted2": "購票指引已在開賣之前24-48小時發送至您的電郵。",
            "_regdone1": "註冊編號",
            "_regdone2": "您已註冊",
            "_regdone3": "重新發送購票指引"
        },
        "_registration_confirm": {
            "_regtext1": "你的個人資料是最新的嗎？",
            "_regtext2": "請確認你的註冊信息以",
            "_regguest1": "你必須先登錄才能登記活動。",
            "_regpending1": "即將完成",
            "_regpending2": "請驗證您<strong>的電郵地址</strong>以解鎖註冊權限。",
            "_updateinfobtn": "更新我的個人資料",
            "_confirmreg": "確認我的註冊",
            "privacytext": "隱私政策",
            "termsofuse": "使用條款",
            "_agreesignup": "我同意Ultra Passport™的隱私政策和使用條款。",
            "_agreesignup2": "通過註冊，你表示同意Ultra Passport™的隱私政策和使用條款。",
            "_agreeregister": "通過註冊，你表示同意Ultra Passport™的隱私政策和使用條款。"
        },
        "_errors": {
            "reset": "無效的電郵地址或指令已過期。",
            "create": "創建失敗，請確保已啟用Cookie。",
            "general": "啊噢！出了些問題。請確保你已啟用Cookie。",
            "password": "密碼必須至少8個字符。",
            "duplicateemail": "此電郵帳戶已被使用。",
            "matchemail": "Your email addresses don\'t match. Please confirm and reenter your email address.",
            "loginfail": "你輸入的用戶名和密碼與我們的記錄不符，請仔細檢查後再重試。",
            "token": "無效的指令，請嘗試登錄並<b>重新發送驗證電子郵件</b>",
            "birthday" : "You must be 18 years of age or older to enroll in Ultra Passport."
        },
        "_passport_labels": {
            "_action": "行動",
            "_awarded": "已獲獎賞",
            "_award": "獎賞",
            "_pointsexpire": "*積分將在25個月後過期",
            "_qualifydisclaimer": "*請注意，“全部Ultra Festival”不包括：Road To Ultra，Ultra Beach和Resistance的活動。",
            "_benefit": "優待",
            "_sample": "已獲積分",
            "_active": "活動中",
            "_deleted": "已刪除",
            "_btn_dashboard": "儀表板",
            "_btn_benefits": "優待",
            "_btn_qualify": "合資格",
            "_btn_points": "我的積分",
            "_howtoqualify": "如何成為合資格會員"
        },
        "_point_labels": {
            "_points_manual": "Passport管理員調整",
            "_points_verify": "驗證電郵帳戶",
            "_points_attend_festival": "參加Road to Ultra的活動",
            "_points_away_bonus": "參加其他國家舉行的活動",
            "_points_home_bonus_1": "參加所在地的活動",
            "_points_home_bonus_2": "參加所在地的活動X2",
            "_points_home_bonus_3": "參加所在地的活動X3"
        },

        /*"// PHP LABELS": {
            "$newpassword": "輸入新密碼",
            "$chooseanewpass": "請選擇新密碼",
            "$enteryouremail": "輸入你的電郵地址",
            "$optional": "非必要"
        },
        "// BUTTON TEXT": {
            "$goback": "返回",
            "$login": "登入",
            "$signup": "註冊",
            "$requestnewpass": "要求重新設置密碼",
            "$buttonverify": "認證",
            "$resetpassword": "重新設置密碼",
            "$createmyaccount": "創建我的賬戶",
            "$updatemyaccount": "更新我的賬戶",
            "$backtologin": "回到登入頁面",
            "$forgotpass": "忘記密碼？"
        },
        "// CONTENT": {
            "$abouttitle": "關於我",
            "$upptitle": "Passport詳情",
            "$updatestext": "請選擇你想要接收更新資訊的活動。",
            "$allupdates": "接收全部更新資訊",
            "$disableall": "取消所有選項",
            "$terms1": "我同意於",
            "$terms2": "通過註冊，你同意",
            "$privacypolicy": "隱私政策",
            "$termsofuse": "使用條款",
            "$and": "還有",
            "$guestnotice": "你必須先登錄才能訪問此頁面。",
            "$searchtext": "輸入以搜尋活動..."
        },
        "// DASHBOARD": {
            "$myaccount": "我的Passport",
            "$points": "積分",
            "$nextlevel": "下一級",
            "$name": "姓名",
            "$location": "地區",
            "$customerid": "客戶身份証明編號",
            "$created": "創立",
            "$level": "級別",
            "$eventsbtn": "活動",
            "$updatesbtn": "最後消息",
            "$editaccount": "編輯帳戶",
            "$ppdetails": "Passport詳情",
            "$ppid": "Passport身份証明編號",
            "$ppunlock": "積分用作解鎖下一個級別",
            "$status": "狀態"
        },
        "// URL SLUGS": {
            "$accountpath": "passport",
            "$loginpath": "登入",
            "$signuppath": "註冊",
            "$lostpath": "失去",
            "$resetpath": "重設",
            "$eventspath": "活動",
            "$verifypath": "認證",
            "$changeemail": "更改電郵地址",
            "$editpath": "編輯",
            "$updatespath": "最新消息"
        },
        "// PAGE TITLES": {
            "title_my_passport": "我的Passport",
            "title_Login": "登入",
            "title_ultra_passport_enrollment": "Ultra Passport登記",
            "title_reset_your_password": "重設您的密碼",
            "title_update_your_password": "更新您的密碼",
            "title_events": "活動",
            "title_verify": "驗證",
            "title_change_email": "更改電郵地址",
            "title_edit_my_account": "編輯我的帳戶",
            "title_manage_updates": "管理更新"
        },*/
        "_benefits": {
            "_silverbenefits_1": "領先大眾一步登記取得Ultra活動的早鳥票",
            "_goldbenefits_1": "在白銀級買家和普通大眾前獲得早期鳥票",
            "_goldbenefits_2": "使用單獨的線路進入音樂節",
            "_goldbenefits_3": "進入Ultra Passport休息室",
            "_goldbenefits_4": "優先客戶服務",
            "_platinumbenefits_1": "在黃金和白銀級護照持有者和普通大眾之前獲得入場券",
            "_platinumbenefits_2": "視具體情況而定，訪問特定觀看平台以選擇明星演出",
            "_platinumbenefits_3": "每個音樂節的特殊福利"
        },
        "_qualify": {
            "_qualify_1": "成功確認您的Ultra Passport登記",
            "_qualify_2": "參加一個完整的Ultra Festival",
            "_qualify_3": "參加Road To Ultra的活動",
            "_qualify_4": "獎勵·參加您所在地區以外的任何一個國家的活動",
            "_qualify_5": "獎勵·參加您所在地區內的本土活動",
            "_qualify_6": "獎勵·連續兩年參加您所在地區的本土活動",
            "_qualify_7": "獎勵·連續三年參加您所在地區的本土活動（以及之後的任何連續年份）"
        },
        /*"Footer": {
            "email_footer_1": "此電子郵件是由ULTRA PASSPORT發出的",
            "email_footer_2": "如果您認為這是一個錯誤，請回复並讓我們知道。\n",
            "email_footer_3": "由Ultra Passport授權"
        },
        "Account Confirmation": {
            "email_account_confirmation_subject": "Ultra Passport帳戶確認",
            "email_account_confirmation_message": "請確認您的Ultra Passport的電郵地址",
            "email_account_confirmation_button": "激活帳戶"
        },
        "Account Verified": {
            "email_account_verified_subject": "帳戶已被驗證",
            "email_account_verified_message": "您已成功確認您的Ultra Passport電郵地址。 您現在可以登記活動，賺取積分，並提高您的Ultra Passport級別。",
            "email_account_verified_button": "查看活動"
        },
        "New Email Verification": {
            "email_new_email_verification_subject": "請驗證您的新電郵地址",
            "email_new_email_verification_message": "請點擊下面的按鈕以確認您的新郵件：",
            "email_new_email_verification_button": "驗證電郵地址"
        },
        "New Email Verified": {
            "email_new_email_verified_subject": "您的新電郵地址己被驗證",
            "email_new_email_verified_message": "您已成功確認您新的Ultra Passport帳戶電郵地址。",
            "email_new_email_verified_button": "查看活動"
        },
        "Forgot Password": {
            "email_forgot_password_subject": "重設您的Ultra Passport密碼",
            "email_forgot_password_message": "點擊下面的按鈕以重設密碼：",
            "email_forgot_password_button": "重設密碼"
        },
        "Password Reset": {
            "email_password_reset_subject": "你的密碼已重設",
            "email_password_reset_message": "這封電郵是通知您，您的密碼己被重設",
            "email_password_reset_button": "我的帳戶"
        },
        "No Account": {
            "email_no_account_subject": "此帳戶不存在",
            "email_no_account_message": "我們無法找到任何與％email％關聯的帳戶，請於以下創立你的帳戶。",
            "email_no_account_button": "立即註冊"
        },
        "EMAIL LABELS": {
            "email_label_intro": "親愛的 (名字)",
            "email_label_intro_guest": "親愛的顧客",
            "email_label_confirm_receipt": "此電子郵件確認我們已收到以下信息。如果需要回覆，我們會盡快與你聯繫。",
            "email_label_sent_from": "發送來自",
            "email_label_generated": "這封電子郵件是通過$ website_link網站提交的。如果這是一個錯誤，請回复並告訴我們。",
            "email_label_contact_request": "聯絡請求\n",
            "email_label_point_of_contact": "您收到此電子郵件是因為您是.get_bloginfo（姓名）的聯繫人。如果您不想再收到這些電子郵件，請通知我們",
            "email_label_terms_of_use": "使用條款",
            "email_label_privacy_policy": "私隱條例"
        },
        "Form Fields": {
            "email_form_success": "成功",
            "email_form_thank_you": "（姓名）感謝您聯繫[sitename]。 <br><br>我們會儘快回复您。"
        }*/
    };



    var

  // Config = '// Config',
  locale = 'zh-tw',
  helpurl = 'https://ultrapassport.com/help/',
  _lwidth = '3em';


  // Globals = '// Globals',
  _globalnotice    = zh_hk_strings['globals']['_globalnotice'];
  _globalnotice2   = zh_hk_strings['globals']['_globalnotice2'];
  _globalnoticereg = zh_hk_strings['globals']['_globalnoticereg'];
  _maintenance     = zh_hk_strings['globals']['_maintenance'];
  _guestnotice     = zh_hk_strings['globals']['_guestnotice'];

  // Labels = '// Labels',
  _fullname            = zh_hk_strings['form_labels']['_fullname'];
  _firstname           = zh_hk_strings['form_labels']['_firstname'];
  _lastname            = zh_hk_strings['form_labels']['_lastname'];
  _email               = zh_hk_strings['form_labels']['_email'];
  _emailaddy           = zh_hk_strings['form_labels']['_emailaddy'];
  _confirmemailaddy    = zh_hk_strings['form_labels']['_confirmemailaddy'];
  _birthday            = zh_hk_strings['form_labels']['_birthday'];
  _location            = zh_hk_strings['form_labels']['_location'];
  _country             = zh_hk_strings['form_labels']['_country'];
  _homeevent           = zh_hk_strings['form_labels']['_homeevent'];
  _gender              = zh_hk_strings['form_labels']['_gender'];
  _password            = zh_hk_strings['form_labels']['_password'];
  _male                = zh_hk_strings['form_labels']['_male'];
  _female              = zh_hk_strings['form_labels']['_female'];
  _pleaseselect        = zh_hk_strings['form_labels']['_pleaseselect'];
  _signuptitle         = zh_hk_strings['form_labels']['_signuptitle'];
  _enteryouremail      = zh_hk_strings['form_labels']['_enteryouremail'];
  _backtologin         = zh_hk_strings['form_labels']['_backtologin'];
  _requestnewpass      = zh_hk_strings['form_labels']['_requestnewpass'];
  _on                  = zh_hk_strings['form_labels']['_on'];
  _off                 = zh_hk_strings['form_labels']['_off'];
  _enrollmentavailable = zh_hk_strings['labels']['_enrollmentavailable'];
  _goback = '返回';


  // Text Labels = '// Text Labels',
  _logintext  = zh_hk_strings['labels']['_logintext'];
  _password   = zh_hk_strings['labels']['_password'];
  _welcome    = zh_hk_strings['labels']['_welcome'];
  _account    = zh_hk_strings['labels']['_account'];
  _myaccount  = zh_hk_strings['labels']['_myaccount'];
  _mypassport = zh_hk_strings['labels']['_mypassport'];
  _events     = zh_hk_strings['labels']['_events'];
  _points     = zh_hk_strings['labels']['_points'];
  _updates    = zh_hk_strings['labels']['_updates'];
  _signout    = zh_hk_strings['labels']['_signout'];
  _signin     = zh_hk_strings['labels']['_signin'];
  _signedin   = zh_hk_strings['labels']['_signedin'];
  _signuptext = zh_hk_strings['labels']['_signuptext'];
  _nextlevel  = zh_hk_strings['labels']['_nextlevel'];
  _forgot     = zh_hk_strings['labels']['_forgot'];
  _subscribed = zh_hk_strings['labels']['_subscribed'];
  _helpcenter = zh_hk_strings['labels']['_helpcenter'];
  _error      = zh_hk_strings['labels']['_error'];
  _silver     = zh_hk_strings['labels']['_silver'];
  _gold       = zh_hk_strings['labels']['_gold'];
  _platinum   = zh_hk_strings['labels']['_platinum'];

  // Validation Messages = '// Validation Messages',
  _gendertext = zh_hk_strings['validation_messages']['_gendertext'];
  _accepttext = zh_hk_strings['validation_messages']['_accepttext'];


  // Email Verifications = '// Email Verifications',
  _resendverify         = zh_hk_strings['_email_verifications']['_resendverify'];
  _revalidate           = zh_hk_strings['_email_verifications']['_revalidate'];
  _sendingverification  = zh_hk_strings['_email_verifications']['_sendingverification'];
  _verifysent           = zh_hk_strings['_email_verifications']['_verifysent'];
  _emailverifydashboard = zh_hk_strings['_email_verifications']['_emailverifydashboard'];
  _emailverifyupdates   = zh_hk_strings['_email_verifications']['_emailverifyupdates'];


  // Edit Page = '// Edit Page',
  _editaccount          = zh_hk_strings['_edit_page']['_editaccount'];
  _nochanges            = zh_hk_strings['_edit_page']['_nochanges'];
  _accountupdated       = zh_hk_strings['_edit_page']['_accountupdated'];
  _emailupdatedstarted  = zh_hk_strings['_edit_page']['_emailupdatedstarted'];
  _emailupdatedverified = zh_hk_strings['_edit_page']['_emailupdatedverified'];
  _passwordresetsent    = zh_hk_strings['_edit_page']['_passwordresetsent'];


  // Footer Signup = '// Footer Signup',
  _startinput = zh_hk_strings['_footer_signup']['_startinput'];
  _starttext  = zh_hk_strings['_footer_signup']['_starttext'];
  _getstarted = zh_hk_strings['_footer_signup']['_getstarted'];


  // Signup Page = '// Signup Page',
  _createaccount        = zh_hk_strings['_signup_page']['_createaccount'];
  _almost               = zh_hk_strings['_signup_page']['_almost'];
  _almost2              = zh_hk_strings['_signup_page']['_almost2'];
  _almost3              = zh_hk_strings['_signup_page']['_almost3'];
  _almost4              = zh_hk_strings['_signup_page']['_almost4'];
  _almost5              = zh_hk_strings['_signup_page']['_almost5'];
  _createdsuccess       = zh_hk_strings['_signup_page']['_createdsuccess'];
  _createdinfo          = zh_hk_strings['_signup_page']['_createdinfo'];
  _accountactivated     = zh_hk_strings['_signup_page']['_accountactivated'];
  _accountverified      = zh_hk_strings['_signup_page']['_accountverified'];
  _passwordresetsuccess = zh_hk_strings['_signup_page']['_passwordresetsuccess'];


  // Updates = '// Updates',
  _updatestext1       = zh_hk_strings['_updates']['_updatestext1'];
  _updatestextPending = zh_hk_strings['_updates']['_updatestextPending'];
  _updatessubsrcibe   = zh_hk_strings['_updates']['_updatessubsrcibe'];
  _updatesunsubsrcibe = zh_hk_strings['_updates']['_updatesunsubsrcibe'];


  // Registration = '// Registration',
  _rbtnbuy             = zh_hk_strings['_registration']['_rbtnbuy'];
  _regbuy              = zh_hk_strings['_registration']['_regbuy'];
  _rbtnregister        = zh_hk_strings['_registration']['_rbtnregister'];
  _rbtnclosed          = zh_hk_strings['_registration']['_rbtnclosed'];
  _rbtnsoon            = zh_hk_strings['_registration']['_rbtnsoon'];
  _rbtnupdates         = zh_hk_strings['_registration']['_rbtnupdates'];
  _verifyemailregister = zh_hk_strings['_registration']['_verifyemailregister'];
  _regbtnhtml          = zh_hk_strings['_registration']['_regbtnhtml'];
  _regerror            = zh_hk_strings['_registration']['_regerror'];
  _regerror2           = zh_hk_strings['_registration']['_regerror2'];
  _regprocessing       = zh_hk_strings['_registration']['_regprocessing'];
  _registersuccess     = zh_hk_strings['_registration']['_registersuccess'];
  _regaccepted         = zh_hk_strings['_registration']['_regaccepted'];
  _regaccepted2        = zh_hk_strings['_registration']['_regaccepted2'];
  _regaccepted2_2      = zh_hk_strings['_registration']['_regaccepted2_2'];
  _regaccepted2_3      = zh_hk_strings['_registration']['_regaccepted2_3'];
  _regaccepted3        = zh_hk_strings['_registration']['_regaccepted3'];
  _regdone1            = zh_hk_strings['_registration']['_regdone1'];
  _regdone2            = zh_hk_strings['_registration']['_regdone2'];
  _regdone3            = zh_hk_strings['_registration']['_regdone3'];
  _selectregtype = '選擇登記類別',
  _regtype = '登記類別',


  // Registrations Confirm = '// Registrations Confirm',
  _regtext1      = zh_hk_strings['_registration_confirm']['_regtext1'];
  _regtext2      = zh_hk_strings['_registration_confirm']['_regtext2'];
  _regguest1     = zh_hk_strings['_registration_confirm']['_regguest1'];
  _regpending1   = zh_hk_strings['_registration_confirm']['_regpending1'];
  _regpending2   = zh_hk_strings['_registration_confirm']['_regpending2'];
  _updateinfobtn = zh_hk_strings['_registration_confirm']['_updateinfobtn'];
  _confirmreg    = zh_hk_strings['_registration_confirm']['_confirmreg'];


  // Privacy / Terms Notice = '// Privacy / Terms Notice',
  privacytext = zh_hk_strings['privacytext'];
  termsofuse  = zh_hk_strings['termsofuse'];

  // Copyright == '// Copyright ',
  upptextlogo    = 'Ultra Passport<span class="tm">&trade;</span>';
  privacylink    = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${zh_hk_strings['_registration_confirm']['privacytext']}</a>`;
  termslink      = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${zh_hk_strings['_registration_confirm']['termsofuse']}</a>`;
  _agreesignup   = zh_hk_strings['_registration_confirm']['_agreesignup'];
  _agreesignup2  = zh_hk_strings['_registration_confirm']['_agreesignup2'];
  _agreeregister = zh_hk_strings['_registration_confirm']['_agreeregister'];


  // Passport Dashboard = '// Passport Dashboard',
  _action            = zh_hk_strings['_passport_labels']['_action'];
  _awarded           = zh_hk_strings['_passport_labels']['_awarded'];
  _award             = zh_hk_strings['_passport_labels']['_award'];
  _benefit           = zh_hk_strings['_passport_labels']['_benefit'];
  _howtoqualify      = zh_hk_strings['_passport_labels']['_howtoqualify'];
  _pointsexpire      = zh_hk_strings['_passport_labels']['_pointsexpire'];
  _qualifydisclaimer = zh_hk_strings['_passport_labels']['_qualifydisclaimer'];
  _active            = zh_hk_strings['_passport_labels']['_active'];
  _deleted           = zh_hk_strings['_passport_labels']['_deleted'];
  _btn_dashboard     = zh_hk_strings['_passport_labels']['_btn_dashboard'];
  _btn_benefits      = zh_hk_strings['_passport_labels']['_btn_benefits'];
  _btn_qualify       = zh_hk_strings['_passport_labels']['_btn_qualify'];
  _btn_points        = zh_hk_strings['_passport_labels']['_btn_points'];

  leveltext = _silver;
  nextlevel = _gold;


    // Errors : '// Errors',
    var errors = zh_hk_strings['_errors'];

    // Point Labels : '// Point Labels'
    var pointcodes = {
        manual : zh_hk_strings['_point_labels']['_points_manual'],
        verify : zh_hk_strings['_point_labels']['_points_verify'],
        unknown : 'Passport Admin Adjustment',
        attend_festival : zh_hk_strings['_point_labels']['_points_attend_festival'],
        attend_rtu : zh_hk_strings['_point_labels']['_points_attend_rtu'],
        attend_resistance : 'Attend a Resistance Only Event',
        away_bonus : zh_hk_strings['_point_labels']['_points_away_bonus'],
        home_bonus_1 : zh_hk_strings['_point_labels']['_points_home_bonus_1'],
        home_bonus_2 : zh_hk_strings['_point_labels']['_points_home_bonus_2'],
        home_bonus_3 : zh_hk_strings['_point_labels']['_points_home_bonus_3'],
    };

}
